import React, { useEffect } from "react";

import EuropaStarten from "../components/cover/animations/europastarten";
import background from "@cover/europastarten/background-1.jpg";
import backgroundSm from "@cover/europastarten/background-1-sm.jpg";

import eyeSrc from '@assets/eye.svg';
import articleSrc from '@assets/article.svg';

export const meta = {
  category: "start",
  slug: "europa",
	id: "EuropaStarten",
  name: "europastarten",
  title: "Grenzgänger",
	excerpt: {
		before: "Der Reim fließt wie der Rhein – tief rein ins Meer Worte können Grenzen verwischen als ob sie flüssig wären Wäre ich ein Zeichen im Satz, wäre ich ein Bindestrich Er hält die Dinge zusammen, die Kräfte bündeln sich",
	},
  animation: EuropaStarten,
  cover: {
    background: {
      lg: background,
      sm: backgroundSm,
    },
		alt: "Die Rapper des deutsch-französischen Duos Zweierpasch stehen nebeneinander, zwischen einer zerrissenen Landkarte und umgeben von den Sternen der Europaflagge. Mit ihrem Tun lassen sie die Grenze zwischen Frankreich und Deutschland verschwinden."
  },
};

const EuropastartenArticle = () => {
  return (
    <div>
			<p className="articleQuestion">
				Intro: Discours de Charles de Gaulle 1963 <i>(Traité de l’Elysée)</i>
      </p>

			<p className="articleHighlight">
				Il n’y a pas un homme dans le monde qui ne mesure l’importance capitale de cet acte. Non pas seuleument parce qu’il tourne la page après une si longue et si sanglante histoire de lutte et de combat ...
      </p>

			<p className="articleQuestion">
				Refrain
      </p>
			<p className="articleParagraph">
				Wir überschreiten Grenzen, grenzenlos über Grenzen
				<br />
				<i>On dépasse les frontières, on fait tomber les barrières</i>
				<br />
				Grenzgänger, on est des frontaliers
				<br />
				<i>Le rap le langage, les mots les bagages</i>
      </p>

			<p className="articleQuestion">
				Strophe 1
      </p>
			<p className="articleParagraph">
				Ich bin Grenzgänger – Frequenz auf zwei Sendern
				<br />
				Grenzüberschreitend geerdet in zwei Ländern
				<br />
				Durch meine Wurzeln geprägt – Gefühl von Heimat
				<br />
				Doch stetem Hang zum frankophilen Einschlag
				<br />
				<i>Etant jeune, grand voyageur, j’ai exploré</i>
				<br />
				<i>Une grande passion : la France m’a vraiment fasciné</i>
				<br />
				<i>Attiré par l’altérité de l’étranger</i>
				<br />
				<i>J’ai commencé à osciller comme un frontalier</i>
				<br />
				<br />
				Wir überschreiten Grenzen wie Caesar damals den Rubikon
				<br />
				Mentale Mauern bekämpfen wir mit dem Lexikon
				<br />
				Und der Rap-Musik – Texte auf fetten Beats
				<br />
				Oft auf Französisch und Deutsch, weil das den Flavour gibt
				<br />
				<i>La langue me facilite l’accès aux deux pays</i>
				<br />
				<i>Et franchement grâce à la musique je réfléchis</i>
				<br />
				<i>Sur la vie et les frontières à dépasser</i>
				<br />
				<i>Le passé m’a donné l’esprit d’un transfrontalier</i>
      </p>

			<p className="articleQuestion">
				Strophe 2
      </p>
			<p className="articleParagraph">
				Der Reim fließt wie der Rhein – tief rein ins Meer
				<br />
				Worte können Grenzen verwischen als ob sie flüssig wären
				<br />
				Wäre ich ein Zeichen im Satz, wäre ich ein Bindestrich
				<br />
				Er hält die Dinge zusammen, die Kräfte bündeln sich
				<br />
				<i>Supprime les obstacles, dépasse les frontières</i>
				<br />
				<i>Il faut se débarrasser des murs imaginaires</i>
				<br />
				<i>Passons à travers ça, faisons le nécessaire</i>
				<br />
				<i>Mettons nos forces ensemble, sinon c’est la galère</i>
				<br />
				<br />
				Wir wollen Brücken schlagen – Grenzen verwischen
				<br />
				Indem wir einfach dazwischenfischen – verbinden wie Brückentage
				<br />
				Wir schwenken eine Fahne – doch nicht mit drei Farben – hier
				<br />
				Wird Schwarz-Rot-Gold mit Blau-Weiß-Rot garniert
				<br />
				<i>Je ne suis pas en délire – j’essaie de jeter des passerelles</i>
				<br />
				<i>Mon point de mire – à force de l’écrire</i>
				<br />
				<i>J’utilise mon micro comme porte-voix</i>
				<br />
				<i>Pour déclarer dans l’unité une heure de gloire</i>
      </p>

			<p className="articleQuestion">
				Strophe 3
      </p>
			<p className="articleParagraph">
				Auf den Spuren De Gaulles und Konrad Adenauers
				<br />
				Wir überwinden Barrieren wie die Berliner Mauer
				<br />
				Sprache ist Medium – Rap ist mein Element
				<br />
				Wir vereinen die beiden und senden’s in die Welt:
				<br />
				<i>Ensemble c’est tout selon Audrey Tautou</i>
				<br />
				<i>On dépasse les frontières on met un passe-partout</i>
				<br />
				<i>De Paris à Berlin, Fribourg à Strasbourg</i>
				<br />
				<i>Tirez dans le même sens: soyez pour!</i>
				<br />
				<br />
				Wir fangen Feuer beim Rappen, brennen auf beiden Seiten
				<br />
				Grenzen sind offen doch manche wollen das nicht begreifen
				<br />
				Wir wollen Flagge zeigen, Grenzen die Grenzen zeigen
				<br />
				Die, die das Denken beschränken, in ihre Schranken weisen
				<br />
				<i>On aime la France même si papi l’a combattue</i>
				<br />
				<i>L’ennemi est devenu poteau, j’en ai beaucoup</i>
				<br />
				<i>Des mecs français, des meufs, on boit des bières ensemble</i>
				<br />
				<i>On rigole bien, on tchatche, on est pépère ensemble</i>
      </p>

			<p className="articleQuestion">
				Outro: Rede von Konrad Adenauer 1963 <i>(Elysée-Vertrag)</i>
      </p>

			<p className="articleParagraph">
				Sie haben die Empfindungen und die Gefühle aller derer, die auf französischer Seite und die auf deutscher Seite an diesem Werke mitgearbeitet haben, so treffend wiedergegeben, dass ich nichts hinzuzufügen brauche ...
      </p>

      <p className="articleHint">
        Die Zeilen stammen aus dem Song „Grenzgänger“ von Zweierpasch. Das
        deutsch-französische Hip-Hop-Duo rappt für offene Grenzen und Völkerverständigung.
      </p>
      <a
        href="https://www.youtube.com/watch?v=vNwA0i4Dgxg"
				target="_blank"
        className="articleLink articleLink--block"
      >
				<div className="articleLinkIcon">
					<img src={eyeSrc} />
				</div>
				<div>
					„Frontalier“ von Zweierpasch
					<div className="articleLinkSource">
						YouTube
					</div>
				</div>
			</a>
			<a
				href="https://www.bwstiftung.de/fileadmin/bw-stiftung/Publikationen/Stiftung/Stiftung_Perspektive_2019-01.pdf#page=32"
				target="_blank"
				className="articleLink articleLink--block"
			>
				<div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					„Das perfekte Doppel“
					<div className="articleLinkSource">
						Perspektive 01/2019
					</div>
				</div>
      </a>
		</div>
	)
};

export default EuropastartenArticle;
